const styles = () => ({
  disconnectedContent: {
    display: 'flex',
    maxWidth: '1000px',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },

  disconnectedRoot: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  dottedLogo: {
    borderRadius: 6,
    width: 60,
    height: 60,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px dashed #e1e9f0',
    marginBottom: 28,
  },

  break: {
    border: '0.5px solid #e1e9f0',
    width: '100%',
    margin: '0 0 23px',
    marginTop: 40,
  },

  disclaimer: {
    marginTop: 9,
  },

  link: {
    textDecoration: 'underline',
  },

  text: {
    color: '#596168',
    fontSize: 15,
    margin: 0,
    maxWidth: 480,
    textAlign: 'center',
  },

  connectorDescription: {
    color: '#596168',
    fontSize: 15,
    maxWidth: 400,
    textAlign: 'center',
    margin: '0 0 32px',
  },
});

export default styles;
